import React from 'react';
import { Box, Container, Typography, Grid, Paper, Stack, ButtonBase } from '@mui/material';
import HomeOutlinedIcon from '@mui/icons-material/HomeOutlined';
import LandingPageNav from '../../components/landingpage/LandingPageNav';
import Footer from '../../components/Footer/footer';

// Set this to your live mortgage payment URL or route
const MORTGAGE_PAYMENT_URL = 'https://account.mortgagequestions.com/phhm/#/login'; // e.g. external: 'https://pay.jethl.com'

const CardButton = ({ icon, label, href }) => (
  <ButtonBase
    focusRipple
    component="a"
    href={href}
    target="_blank"
    rel="noopener noreferrer"
    sx={{
      width: '100%',
      borderRadius: 2,
      textAlign: 'center',
    }}
  >
    <Paper
      elevation={6}
      sx={{
        width: '100%',
        p: { xs: 4, md: 6 },
        borderRadius: 2,
        transition: 'transform 160ms ease, box-shadow 160ms ease',
        '&:hover': { transform: 'translateY(-2px)' },
      }}
    >
      <Stack spacing={2} alignItems="center" justifyContent="center">
        {icon}
        <Typography variant="h4" component="h2">
          {label}
        </Typography>
      </Stack>
    </Paper>
  </ButtonBase>
);


export default function PaymentsLandingPage() {
  return (
    <>
      <LandingPageNav />

      {/* Header & Intro */}
      <Box sx={{ bgcolor: '#f6f7f8', pt: { xs: 10, md: 12 }, pb: { xs: 4, md: 6 } }}>
        <Container maxWidth="md">
          <Typography variant="h1" align="center">
            Submit A Payment
          </Typography>
          <Box sx={{ width: 80, height: 3, bgcolor: 'divider', mx: 'auto', my: 2, borderRadius: 2 }} />
          <Typography variant="body1" align="center" color="text.secondary">
            At Jet HomeLoans, we strive to make each part of the mortgage experience as simple as possible, including making payments. If you need to make a mortgage payment, you’ve come to the right place. Click below and follow the prompt to complete your payment.
          </Typography>
        </Container>
      </Box>

      {/* Cards */}
      <Box sx={{ bgcolor: '#f6f7f8', pb: { xs: 6, md: 10 } }}>
        <Container maxWidth="lg">
          <Grid container spacing={4} justifyContent="center">
            <Grid item xs={12} sm={10} md={6} lg={4}>
              <CardButton
                href={MORTGAGE_PAYMENT_URL}
                label="MORTGAGE PAYMENT"
                icon={<HomeOutlinedIcon sx={{ fontSize: 64, color: 'text.secondary' }} />}
              />
            </Grid>
          </Grid>
        </Container>
      </Box>

      <Footer />
    </>
  );
}
